import { configs } from '@hero/configs';
import { useGetUser } from '@hero/services/organization-service/hooks';

function useIsAutomationEnabled() {
  const { data: user } = useGetUser();

  return configs.automation.enabled && !user?.meta?.isPunchoutUser;
}

export { useIsAutomationEnabled };
